/**
 * 拟落户地址，武汉市下的区县
 */
export const areaLHList = [
    {"val":"420114","title":"蔡甸区"},
    {"val":"420104","title":"硚口区"},
    {"val":"420107","title":"青山区"},
    {"val":"420106","title":"武昌区"},
    {"val":"420117","title":"新洲区"},
    {"val":"420112","title":"东西湖区"},
    {"val":"420113","title":"汉南区"},
    {"val":"420105","title":"汉阳区"},
    {"val":"420111","title":"洪山区"},
    {"val":"420116","title":"黄陂区"},
    {"val":"420102","title":"江岸区"},
    {"val":"420103","title":"江汉区"},
    {"val":"420115","title":"江夏区"},]